// eslint-disable
import { useEffect, useRef, useState, useCallback } from 'react';
import { get, post } from './Remote';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Custom hook to implement setInterval

const shift = 3;

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
    return console.error('Delay cant be null');
  }, [delay]);
};

// Custom hook to implement setTimeout

export const useTimeout = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setTimeout(tick, delay);
      return () => clearTimeout(id);
    }
    return console.error('Delay cannot be null');
  }, [delay]);
};

export const apiValidation = (res, payload = 'result') => {
  if (res && res.success === 1) {
    return res[payload];
  }
  return console.error('The API has failed');
};

// function to implement global color styles

export const setGlobalColors = (primary, light, lightest, superlight, materialObject) => {
  document.body.style.setProperty('--primary-blue', primary);
  document.body.style.setProperty('--lighter-blue', light);
  document.body.style.setProperty('--lightest-blue', lightest);
  document.body.style.setProperty('--superlight-blue', superlight);
  document.body.style.setProperty('--material-light', materialObject.light);
  document.body.style.setProperty('--material-dark', materialObject.dark);
  document.body.style.setProperty('--material-contrastText', materialObject.contrastText);

  // adding theme color of client
  const oldThemeColorMeta = document.querySelector('meta[name="theme-color"]');
  // console.log(oldThemeColorMeta, 'old tag');
  const meta = document.createElement('meta');
  meta.setAttribute('name', 'theme-color');
  meta.setAttribute('content', primary);
  document.getElementsByTagName('head')[0].appendChild(meta);
  document.head.removeChild(oldThemeColorMeta);
  document.head.appendChild(meta);
};

// function to dynamically change document title

export function changeFaviconAndDocumentTitle(favicon, documentTitle) {
  [
    { id: 'dynamic-favicon', rel: 'icon' },
    { id: 'apple-icon', rel: 'apple-touch-icon' },
  ].forEach((elem) => {
    const link = document.createElement('link');
    const oldLink = document.getElementById(elem.id);
    link.id = elem.id;
    link.rel = elem.rel;
    link.href = favicon;
    link.type = 'image/x-icon';

    if (oldLink) {
      document.head.removeChild(oldLink);
    }
    document.head.appendChild(link);
  });
  if (documentTitle) document.title = documentTitle;

  // const link = document.createElement('link');
  // const oldLink = document.getElementById('dynamic-favicon');
  // link.id = 'dynamic-favicon';
  // link.rel = 'shortcut icon';
  // link.href = favicon;
  // document.title = documentTitle;

  // if (oldLink) {
  //   document.head.removeChild(oldLink);
  // }
  // document.head.appendChild(link);
}

// function to check whether development or environment

export function prodOrDev() {
  if (process.env.NODE_ENV === 'development') return 'development';
  if (process.env.NODE_ENV === 'production') return 'production';
  return 'test';
}

// function that sorts according to given parameter (Object key)

export const propComparator = (propName) => (a, b) =>
  a[propName] === b[propName] ? 0 : a[propName] < b[propName] ? -1 : 1;

export const useFocus = () => {
  const htmlElRef = useRef(null);
  const setFocus = () => {
    htmlElRef.current && htmlElRef.current.focus();
  };

  return [htmlElRef, setFocus];
};

// // function to validate file. Ideally should be server side but ab kya kar sakte h lol.

// export const verifyFileExtension = (type, acceptedFile) => {
//   const typeRegex = new RegExp(acceptedFile.replace(/\*/g, '.*').replace(/,/g, '|'));
//   return typeRegex.test(type);
// };

export default function useWindowDimensions() {
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export const urlify = (text) => {
  if (!text) return '';
  if (text.includes('azureedge.net')) return text;
  if (text.includes('cdn.mathpix')) return text;

  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return text.replace(urlRegex, function (url) {
    return isWebView
      ? `<a href="${url}" >${url}</a>`
      : `<a href="${url}" target="_blank">${url}</a>`;
  });
};

export const detectNextLine = (text) => {
  if (!text) return '';
  return text.replace(/\n/g, '<br>');
};

export const generatePreSignedUrl = (url) => {
  return url;
};

export const iosRedirect = (url) => {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.click();
};

export const copyToClipboardHybrid = (text, showToast = true) => {
  if (isWebView && typeof window.Android.copyToClipboard !== 'undefined') {
    window.Android.copyToClipboard(text);
    if (showToast) {
      window.Android.showToast('Copied to clipboard');
    }
  } else if (isIosApp) {
    iosCaller('copyToClipboard', text);
    if(showToast) {
      iosCaller('showToast', 'Copied to clipboard')
    }
  } else {
    navigator.permissions.query({ name: 'clipboard-write' }).then((permissionStatus) => {
      console.log(permissionStatus.state); // 'granted', 'prompt', or 'denied'
      if (permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            
            if(showToast) {
              toastSuccess('Copied');
            }
          })
          .catch((err) => console.error(err));
      } else {
        console.error('Clipboard permissions denied.');
      }
    });
  }
};

export const timestampToHumanDate = (timestamp, type) => {
  // Convert timestamp to milliseconds
  const milliseconds = timestamp * 1000;

  // Create a new Date object
  const date = new Date(milliseconds);

  // Array of month names
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Get day, month, and year
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Format the date
  if (type === 'date') {
    return `${day.toString().padStart(2, '0')} ${monthNames[monthIndex]} ${year}`;
  }

  return `${day.toString().padStart(2, '0')} ${
    monthNames[monthIndex]
  } ${year} at ${hours}:${minutes}`;
};

export const shareThis = (url, content, title = 'Look at this awesome course!') => {
  if (navigator.share) {
    navigator
      .share({
        title,
        // eslint-disable-next-line
        text: content,
        url,
      })
      .then(() => {
        console.log('Thanks for sharing!');
      })
      .catch(console.error);
  } else if (isWebView) {
    window.Android.share(title, `${content} ${url}`);
  } else {
    navigator.clipboard.writeText(url);
  }
};

export const formatDateInEnglish = (date) => {
  if (!date) return null;
  if (date == 'null') return null;
  const format1 = String(new Date(+date * 1000));
  console.log(format1, 'format1');
  const formatArr = format1.split(' '); // [month, date, year]
  const finalFormat = [formatArr[2], formatArr[1], formatArr[3]];
  return finalFormat.join(' ');
};

let isWV = false;

if (typeof window.Android === 'undefined') {
  isWV = false;
} else {
  isWV = true;
}

export const isWebView = isWV;

// export const useDidMountEffect = (func, deps) => {
//   const didMount = useRef(false);

//   useEffect(() => {
//     if (didMount.current) func();
//     else didMount.current = true;
//   }, deps);
// };

const isTouchEvent = (event) => {
  return 'touches' in event;
};

export const hslToHex = (h, s, ll) => {
  const l = ll / 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0'); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};

export const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export function isIphoneOrIpad() {
  const { userAgent } = navigator;

  // Check for iPhone or iPad in the user agent string
  const isIphone = /iPhone/.test(userAgent);
  const isIpad = /iPad/.test(userAgent);

  // Ensure the device is not emulated by checking for real touch support
  const isRealDevice =
    window.matchMedia('(pointer: coarse)').matches &&
    window.innerWidth > 0 &&
    window.innerHeight > 0;

  // Return true only if it is a real iPhone or iPad device and not emulated
  return (isIphone || isIpad) && isRealDevice;
}

let isChromeB = true;
const ua = navigator.userAgent.toLowerCase();
if (ua.indexOf('safari') != -1) {
  if (ua.indexOf('chrome') > -1) {
    isChromeB = true;
  } else {
    isChromeB = false;
  }
}
const isAp = window.navigator.standalone;
export const isIos1 = !isChromeB && isAp;

const preventDefault = (event) => {
  if (!isTouchEvent(event)) return;

  if (event.touches.length < 2 && event.preventDefault) {
    event.preventDefault();
  }
};

// export const convertXlsIntoJson = (oEvent) => {
//   // Get The File From The Input
//   const oFile = oEvent.target.files[0];
//   const sFilename = oFile.name;
//   // Create A File Reader HTML5
//   const reader = new FileReader();

//   // Ready The Event For When A File Gets Selected
//   reader.onload = function (e) {
//     const data = e.target.result;
//     const cfb = XLS.CFB.read(data, { type: 'binary' });
//     const wb = XLS.parse_xlscfb(cfb);
//     // Loop Over Each Sheet
//     wb.SheetNames.forEach(function (sheetName) {
//       // Obtain The Current Row As CSV
//       const sCSV = XLS.utils.make_csv(wb.Sheets[sheetName]);
//       const oJS = XLS.utils.sheet_to_row_object_array(wb.Sheets[sheetName]);

//       // $('#my_file_output').html(sCSV);
//       console.log(oJS, 'myReadData');
//     });
//   };

//   // Tell JS To Start Reading The File.. You could delay this if desired
//   reader.readAsBinaryString(oFile);
// };

// const makeRepeated = (arr, repeats) => Array.from({ length: repeats }, () => arr).flat();
// makes array repeats itself n times....makesRepeat(arr, 5)
export function extractBlobDetails(blobUrl) {
  if (
    blobUrl.includes('azurefrontdoor') ||
    blobUrl.includes('blob.core.windows.net') ||
    blobUrl.includes('azureedge.net')
  ) {
    try {
      // Parse the URL
      const url = new URL(blobUrl);

      // Get the hostname and path
      const pathParts = url.pathname.split('/').filter(Boolean);

      // Extract container name and blob path
      const containerName = pathParts[0];
      const blobPath = pathParts.slice(1).join('/');

      return {
        containerName,
        blobName: decodeURIComponent(blobPath),
      };
    } catch (error) {
      console.error('Invalid URL:', error);
      return { videoId: blobUrl };
    }
  } else if (blobUrl.includes('cloudfront.net/')) {
    const k = decodeURIComponent(blobUrl).split('cloudfront.net/')[1];
    
    const region = 'ap-south-1';
   

    return { bucket: 'ingenium-files', key: k, region, path: k, blobName: k };
  } else {
    return { videoId: blobUrl };
  }
}

export const changeLinkToCloudfront = (link) => {
  let newLink = link;
  if (link.includes('question-images-ingenium')) {
    newLink = link.replace(
      'https://s3.ap-south-1.amazonaws.com/question-images-ingenium/',
      'https://d150gnfeuxp7r1.cloudfront.net/',
    );
  } else if (link.includes('userfiles-ingenium')) {
    newLink = link.replace(
      'https://userfiles-ingenium.s3.ap-south-1.amazonaws.com/',
      'https://d1lo0kv7po0fz1.cloudfront.net/',
    );
  } else if (link.includes('vc-10001093-109316679702')) {
    newLink = link.replace(
      'https://vc-10001093-109316679702.s3.ap-south-1.amazonaws.com/',
      'https://d2tdtly6rg7g3p.cloudfront.net/',
    );
  }
  return newLink;
};

export function encrypt(key) {
  const base64Table = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

  // Step 1: Apply Caesar Cipher
  // eslint-disable
  const shifted = [...key]
    .map((char) => {
      if (/[a-zA-Z0-9]/.test(char)) {
        const charCode = char.charCodeAt(0);
        let str = '';
        if (char >= '0' && char <= '9') {
          str = String.fromCharCode(((charCode - 48 + shift) % 10) + 48);
        } else if (char >= 'A' && char <= 'Z') {
          str = String.fromCharCode(((charCode - 65 + shift) % 26) + 65);
        } else if (char >= 'a' && char <= 'z') {
          str = String.fromCharCode(((charCode - 97 + shift) % 26) + 97);
        }
        return str;
      }
      return char; // Non-alphanumeric characters remain unchanged
    })
    .join('');

  // Step 2: Custom Base64 Encoding
  let binary = '';
  for (const char of shifted) {
    binary += char.charCodeAt(0).toString(2).padStart(8, '0');
  }

  let base64Encoded = '';
  for (let i = 0; i < binary.length; i += 6) {
    const chunk = binary.slice(i, i + 6).padEnd(6, '0'); // Pad incomplete chunks with zeros
    base64Encoded += base64Table[parseInt(chunk, 2)];
  }

  return base64Encoded;
}

export function dc(encryptedKey) {
  const base64Table = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

  // Step 1: Custom Base64 Decoding
  let binary = '';
  for (const char of encryptedKey) {
    const index = base64Table.indexOf(char);
    if (index !== -1) {
      binary += index.toString(2).padStart(6, '0');
    }
  }

  const decoded = [];
  for (let i = 0; i < binary.length; i += 8) {
    const byte = binary.slice(i, i + 8);
    if (byte.length === 8) {
      // Ensure only complete bytes are processed
      decoded.push(String.fromCharCode(parseInt(byte, 2)));
    }
  }

  const decodedString = decoded.join('');

  // Step 2: Reverse the Caesar Cipher
  // eslint-disable
  const original = [...decodedString]
    .map((char) => {
      if (/[a-zA-Z0-9]/.test(char)) {
        const charCode = char.charCodeAt(0);
        let str = '';
        if (char >= '0' && char <= '9') {
          str = String.fromCharCode(((charCode - 48 - shift + 10) % 10) + 48);
        } else if (char >= 'A' && char <= 'Z') {
          str = String.fromCharCode(((charCode - 65 - shift + 26) % 26) + 65);
        } else if (char >= 'a' && char <= 'z') {
          str = String.fromCharCode(((charCode - 97 - shift + 26) % 26) + 97);
        }
        return str;
      }
      return char; // Non-alphanumeric characters remain unchanged
    })
    .join('');

  return original;
}

function detectDevice() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const platform = window.navigator.platform.toLowerCase();

  // Specific detection for iPhone
  const isIPhone =
    /iphone/.test(userAgent) &&
    (/iphone/.test(platform) || /iphone/.test(userAgent)) &&
    // Ensure it's not just an iPod or other device
    !/ipod/.test(userAgent);

  // Specific detection for iPad
  const isIPad =
    (/ipad/.test(userAgent) ||
      // Check for iPad-specific user agent patterns
      (/macintosh/.test(userAgent) && 'ontouchend' in document)) &&
    // Ensure touch capability and avoid mistaking for Mac
    window.screen.width !== window.screen.height;

  if (isIPhone) {
    return 'iPhone';
  }

  if (isIPad) {
    return 'iPad';
  }

  return null;
}

// Usage examples
export function checkDeviceIsIos() {
  const device = detectDevice();

  switch (device) {
    case 'iPhone':
      return true;
      break;
    case 'iPad':
      return true;
      break;
    default:
      return false;
  }
}

export const iOS = () => {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform,
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

export const formatVideoUrl = (url) => {
  if (!url) return url;
  return url.replace('ingeniumcdn', 'ingeniumvideocdn').replace('azurecdn', 'azurevideocdn');
};

export const updateUsageTrack = (client_id, count = 1, service = 'eri') => {
  post({ client_id, count, service }, '/updateUsageTrack').then((res) => {
    if (res && res.success) {
      console.log('updated');
    }
  });
};

export function formatTimestampToReadable12HrFormat(timestamp) {
  const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
  const options = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata', // Convert to IST
  };

  // Convert locale string and ensure AM/PM is uppercase
  return date
    .toLocaleString('en-GB', options)
    .replace(',', '')
    .replace(/\b(am|pm)\b/g, (match) => match.toUpperCase());
}

export function formatTimeWithTimeAgo(publishedAt) {
  const publishedDate = new Date(publishedAt * 1000); // Convert seconds to milliseconds
  const now = new Date();

  if (isNaN(publishedDate.getTime())) return 'Invalid date';

  const isSameDay =
    publishedDate.getFullYear() === now.getFullYear() &&
    publishedDate.getMonth() === now.getMonth() &&
    publishedDate.getDate() === now.getDate();

  if (isSameDay) {
    const diffInMs = now - publishedDate;
    const diffInSec = Math.floor(diffInMs / 1000);
    const diffInMin = Math.floor(diffInSec / 60);
    const diffInHrs = Math.floor(diffInMin / 60);

    if (diffInSec < 60) {
      return 'few seconds ago';
    } else if (diffInMin < 60) {
      return `${diffInMin} min${diffInMin !== 1 ? 's' : ''} ago`;
    } else {
      return `${diffInHrs} hr${diffInHrs !== 1 ? 's' : ''} ago`;
    }
  }

  // Format for previous days
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const dayName = days[publishedDate.getDay()];
  const day = publishedDate.getDate();
  const month = months[publishedDate.getMonth()];
  const hour = String(publishedDate.getHours()).padStart(2, '0');
  const min = String(publishedDate.getMinutes()).padStart(2, '0');
  const year = publishedDate.getFullYear();
  const includeYear = year !== now.getFullYear();

  return `${day} ${month}, ${hour}:${min}${includeYear ? ', ' + year : ''}`;
}

export function getTimeAgo(publishedAt) {
  const publishedDate = new Date(publishedAt);
  const now = new Date();
  const diffInMs = now - publishedDate;

  const diffInSec = Math.floor(diffInMs / 1000);
  const diffInMin = Math.floor(diffInSec / 60);
  const diffInHrs = Math.floor(diffInMin / 60);
  const diffInDays = Math.floor(diffInHrs / 24);
  const diffInWeeks = Math.floor(diffInDays / 7);
  const diffInMonths = Math.floor(diffInDays / 30); // Approximate
  const diffInYears = Math.floor(diffInDays / 365); // Approximate

  if (diffInSec < 60) {
    return 'few seconds ago';
  } else if (diffInMin < 60) {
    return `${diffInMin} min${diffInMin !== 1 ? 's' : ''} ago`;
  } else if (diffInHrs < 24) {
    return `${diffInHrs} hr${diffInHrs !== 1 ? 's' : ''} ago`;
  } else if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
  } else if (diffInWeeks < 4) {
    return `${diffInWeeks} week${diffInWeeks !== 1 ? 's' : ''} ago`;
  } else if (diffInMonths < 12) {
    return `${diffInMonths || 1} month${diffInMonths === 1 ? '' : 's'} ago`;
  } else {
    return `${diffInYears} year${diffInYears !== 1 ? 's' : ''} ago`;
  }
}

export function isHTML(str) {
  if (typeof str !== 'string') return false;

  // This regex looks for tags like <div>, <img src="...">, </p>, etc.
  const htmlPattern = /<([a-z][\s\S]*?)>/i;

  return htmlPattern.test(str.trim());
}
export function getAvatarForUser(userId) {
  if (!userId) return '#d4a373';
  const lastChar = userId.toString().slice(-1);

  const avatarMap = {
    1: '#d4a373',
    2: '#f08080',
    3: '#a0c4ff',
    4: '#abc4ff',
    5: '#84dcc6',
    6: '#b388eb',
    7: '#a7bed3',
    8: '#e7cee3',
    9: '#e4b4c2',
    0: '#fcd29f',
  };

  return avatarMap[lastChar] || '#d4a373'; // fallback to null if invalid userId
}

export function capitalizeWords(str) {
  if (!str) return '';
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export const dataURItoBlob = (dataURI) => {
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString, name: 'prime.png' });
};

export const setPaymentUserAgent = () => {
  if (isWebView && typeof window.Android.setUserAgent !== 'undefined') {
    window.Android.setUserAgent(
      JSON.stringify({
        user_agent:
          'Mozilla/5.0 (Linux; Android 10) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/107.0.0.0 Mobile Safari/537.36',
      }),
    );
    if (isWebView && typeof window.Android.setIsRedirectExternal !== 'undefined') {
      window.Android.setIsRedirectExternal('true');
    }
  } else if (isIosApp) {
    iosCaller('setIsRedirectExternal', 'true');
    iosCaller(
      'setUserAgent',
      'Mozilla/5.0 (iPhone; CPU iPhone OS 15_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.0 Mobile/15E148 Safari/604.1',
    );
  }
};

export const setDefaultUserAgent = () => {
  if (isWebView && typeof window.Android.setUserAgent !== 'undefined') {
    window.Android.setUserAgent(
      JSON.stringify({
        user_agent:
          'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/85.0.4183.83 Safari/537.36',
      }),
    );
    if (isWebView && typeof window.Android.setIsRedirectExternal !== 'undefined') {
      window.Android.setIsRedirectExternal('false');
    }
  } else if (isIosApp) {
    iosCaller('setIsRedirectExternal', 'false');
    iosCaller(
      'setUserAgent',
      'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.0 Safari/605.1.15',
    );
  }
};

export const toastSuccess = (message) =>
  toast(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    theme: 'colored',
    newestOnTop: true,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: 'success',
  });

export const toastError = (message) =>
  toast(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    newestOnTop: true,
    closeOnClick: true,
    theme: 'colored',
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: 'error',
  });

export const toastWarning = (message) =>
  toast(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    newestOnTop: true,
    theme: 'colored',
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: 'warning',
  });

export const getCountryAndCurrency = async () => {
  try {
    const res = await fetch('https://free.freeipapi.com/api/json/');
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const data = await res.json();
    return {
      country_name: data.countryName, // e.g., "India"
      currency_code: data.currencies[0], // e.g., "INR"
      country_code: data.countryCode, // e.g., "IN"
    };
  } catch (err) {
    console.error('Error fetching geolocation data:', err);
    return {
      country_name: 'India', // e.g., "India"
      currency_code: 'INR', // e.g., "INR"
      country_code: 'IN', // e.g., "IN"
    };
  }
};

export const isIosApp = Boolean(window.webkit?.messageHandlers?.iosListener);

export const iosCaller = (action, payload = null, extraPayload = null) => {
  try {
    window.webkit?.messageHandlers?.iosListener?.postMessage({
      action: action,
      message: payload,
    });
  } catch (err) {
    console.log(err);
  }
};

export const OPTION_SEP = '⟐⟐';
// export const OPTION_SEP = '~';

export const getRandomEmoji = () => {
  const emojis = ['🔴', '🟢', '🔵', '🟡'];
  return emojis[Math.floor(Math.random() * emojis.length)];
};

// Function to decode HTML entities
const decodeHtmlEntities = (str) => {
  if (!str || typeof str !== 'string') return '';

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = str;
  return tempDiv.innerHTML;
};

// Function to manually decode common HTML entities
const manualDecodeHtml = (str) => {
  if (!str || typeof str !== 'string') return '';

  return str
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#x27;/g, "'")
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ');
};

// Function to process LaTeX content - handles multiple formats
const processLatexInContent = (htmlContent) => {
  if (!htmlContent) return '';

  let processed = htmlContent;

  // Handle Quill formula spans - convert to MathJax format
  processed = processed.replace(
    /<span[^>]*class="[^"]*ql-formula[^"]*"[^>]*data-value="([^"]*)"[^>]*>.*?<\/span>/g,
    (match, latex) => {
      return `\\(${latex}\\)`;
    },
  );

  // Handle other LaTeX delimiters that might be in the content
  processed = processed
    .replace(/\$\$([^$]+)\$\$/g, '\\[$1\\]') // Display math
    .replace(/\$([^$]+)\$/g, '\\($1\\)'); // Inline math

  return processed;
};

const processSmilesInContent = (htmlContent) => {
  if (!htmlContent) return '';

  let processed = htmlContent;

  // Find all SMILES tags - check both encoded and unencoded versions
  const smilesRegex = /<smiles>(.*?)<\/smiles>/gi;
  const encodedSmilesRegex = /&lt;smiles&gt;(.*?)&lt;\/smiles&gt;/gi;

  let foundSmiles = false;

  // Handle regular SMILES tags - Use multiple high-quality services with fallbacks
  processed = processed.replace(smilesRegex, (match, smilesCode) => {
    foundSmiles = true;
    const cleanSmiles = smilesCode.trim();
    console.log('✓ Found SMILES:', cleanSmiles);

    // CACTUS SVG with transparent background - best option for transparency
    const cactusSvgUrl = `https://cactus.nci.nih.gov/chemical/structure/${encodeURIComponent(
      cleanSmiles,
    )}/image?format=svg&width=500&height=300&bgcolor=transparent`;

    // PubChem with transparent background parameter
    const pubchemUrl = `https://pubchem.ncbi.nlm.nih.gov/rest/pug/compound/smiles/${encodeURIComponent(
      cleanSmiles,
    )}/PNG?image_size=large&bgcolor=transparent`;

    // Alternative: ChemSpider API (if available) - usually has good transparent backgrounds
    const chemSpiderUrl = `https://www.chemspider.com/ImagesHandler.ashx?smiles=${encodeURIComponent(
      cleanSmiles,
    )}&w=500&h=300`;

    return `<div class="smiles-wrapper" style="display: flex; margin:  0px;  background: transparent;">
        <img src="${cactusSvgUrl}" alt="Chemical Structure: ${cleanSmiles}" 
             style="max-width: 350px; margin: -40px auto; height: auto; display: block; background: transparent;" 
             onerror="this.onerror=null; this.src='${pubchemUrl}'; this.onerror=function(){ this.onerror=null; this.src='${chemSpiderUrl}'; };" />
      </div>`;
  });

  // Handle encoded SMILES tags
  processed = processed.replace(encodedSmilesRegex, (match, smilesCode) => {
    foundSmiles = true;
    const cleanSmiles = smilesCode.trim();
    console.log('✓ Found encoded SMILES:', cleanSmiles);

    const cactusSvgUrl = `https://cactus.nci.nih.gov/chemical/structure/${encodeURIComponent(
      cleanSmiles,
    )}/image?format=svg&width=500&height=300&bgcolor=transparent`;
    const pubchemUrl = `https://pubchem.ncbi.nlm.nih.gov/rest/pug/compound/smiles/${encodeURIComponent(
      cleanSmiles,
    )}/PNG?image_size=large&bgcolor=transparent`;
    const chemSpiderUrl = `https://www.chemspider.com/ImagesHandler.ashx?smiles=${encodeURIComponent(
      cleanSmiles,
    )}&w=500&h=300`;

    return `<div class="smiles-wrapper" style="display: flex; margin:  0px; background: transparent; ">
        <img src="${cactusSvgUrl}" alt="Chemical Structure: ${cleanSmiles}" 
             style="max-width: 350px; margin-bottom: -40px auto; height: auto; display: block; background: transparent;" 
             onerror="this.onerror=null; this.src='${pubchemUrl}'; this.onerror=function(){ this.onerror=null; this.src='${chemSpiderUrl}'; };" />
      </div>`;
  });

  if (foundSmiles) {
    console.log('✓ SMILES tags found and replaced with images');
  }

  return processed;
};

export const processHtmlContent = (content) => {
  if (!content) return '';

  let processed = content;

  // Step 1: Handle different encoding scenarios
  if (typeof processed === 'string') {
    // Check if content is HTML-encoded (contains entities like &lt;, &gt;)
    if (processed.includes('&lt;') || processed.includes('&gt;') || processed.includes('&amp;')) {
      // First try manual decoding
      processed = manualDecodeHtml(processed);
      // Then try browser decoding as backup
      if (processed.includes('&')) {
        processed = decodeHtmlEntities(processed);
      }
    }
  }

  // Step 2: Clean up problematic characters
  processed = processed.replace(/"/g, '"'); // Normalize quotes

  processed = processSmilesInContent(processed);

  // Step 3: Process LaTeX content
  processed = processLatexInContent(processed);

  return processed;
};

export const getWebDeviceInfo = () => {
  // 1. Retrieve or Generate the Unique ID
  let deviceId = localStorage.getItem('web_device_id');

  if (!deviceId) {
    // Generate a standard UUID v4.
    // Note: crypto.randomUUID() requires a secure context (HTTPS)
    deviceId = crypto.randomUUID ? crypto.randomUUID() : generateFallbackUUID();
    localStorage.setItem('web_device_id', deviceId);
  }

  // 2. Determine OS (Basic detection via User-Agent)
  const ua = navigator.userAgent;
  let osVersion = 'Unknown OS';
  if (ua.indexOf('Win') !== -1) osVersion = 'Windows';
  if (ua.indexOf('Mac') !== -1) osVersion = 'MacOS';
  if (ua.indexOf('Linux') !== -1) osVersion = 'Linux';
  if (ua.indexOf('X11') !== -1) osVersion = 'UNIX';

  // 3. Compile the Data
  const deviceData = {
    deviceId: deviceId,
    deviceType: 'Web Browser',
    model: getBrowserName(ua),
    osVersion: osVersion,
    userAgent: ua,
  };

  return deviceData;
};

export function generateUserReferalCode(userId) {
  // Never dare to change/delete this algorithm
  // This function generates a unique 5-character alphanumeric code based on the client ID for ios org_code.
  const SECRET_PRIME = 19289; // a large prime number (coprime with 36^5)
  const SECRET_OFFSET = 24080; // random offset
  const BASE = 36; // base36 → 0-9, A-Z
  const MODULUS = Math.pow(BASE, 5); // 60,466,176

  if (userId < 1 || userId > 10_000_000) {
    throw new Error("Client ID out of range (1–10,000,000)");
  }

  // Step 1: Mix the ID with a prime and offset (obfuscation)
  let mixed = (userId * SECRET_PRIME + SECRET_OFFSET) % MODULUS;

  // Step 2: Convert to base36 (alphanumeric)
  let code = mixed.toString(BASE).toUpperCase();

  // Step 3: Pad to 5 characters
  return code.padStart(5, "0");
}


// Helper: Basic browser name extraction from User-Agent
function getBrowserName(userAgent) {
  if (userAgent.includes('Firefox')) return 'Firefox';
  if (userAgent.includes('SamsungBrowser')) return 'Samsung Internet';
  if (userAgent.includes('Opera') || userAgent.includes('OPR')) return 'Opera';
  if (userAgent.includes('Trident')) return 'Internet Explorer';
  if (userAgent.includes('Edge') || userAgent.includes('Edg')) return 'Edge';
  if (userAgent.includes('Chrome')) return 'Chrome';
  if (userAgent.includes('Safari')) return 'Safari';
  return 'Unknown Browser';
}

// Helper: Fallback UUID generator if crypto.randomUUID is unavailable
function generateFallbackUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function timestampToWhatsappFormat(timestampInSeconds) {
  if (!timestampInSeconds) return '';
  const date = new Date(timestampInSeconds * 1000);
  const now = new Date();

  // Helper: check if two dates are the same calendar day
  const isSameDay = (d1, d2) =>
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();

  // Helper: get the difference in whole calendar days (ignoring time)
  const daysDiff = (d1, d2) => {
    const start = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());
    const end = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
    return Math.round((start - end) / (1000 * 60 * 60 * 24));
  };

  if (isSameDay(date, now)) {
    // Case 1: Same day → 12-hour time format (e.g. "3:45 PM")
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  }

  const diff = daysDiff(date, now);

  if (diff <= 7) {
    // Case 2: Within the last 7 days → Day name (e.g. "Friday")
    return date.toLocaleDateString('en-US', { weekday: 'long' });
  }

  // Case 3: More than 7 days ago → dd/mm/yyyy (e.g. "15/03/2024")
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

function modInverse(a, m) {
  let [old_r, r] = [a, m];
  let [old_s, s] = [1, 0];

  while (r !== 0) {
    const quotient = Math.floor(old_r / r);
    [old_r, r] = [r, old_r - quotient * r];
    [old_s, s] = [s, old_s - quotient * s];
  }

  if (old_r !== 1) {
    throw new Error("SECRET_PRIME is not invertible mod MODULUS — check that they are coprime");
  }

  // Ensure positive result
  return ((old_s % m) + m) % m;
}

export function decodeReferralCode (code) {
  const SECRET_PRIME = 19289;
  const SECRET_OFFSET = 24080;
  const BASE = 36;
  const MODULUS = Math.pow(BASE, 5); // 60,466,176

  // Step 1: Parse the base36 code back into the "mixed" number
  const mixed = parseInt(code, BASE);

  if (isNaN(mixed) || mixed < 0 || mixed >= MODULUS) {
    throw new Error("Invalid referral code");
  }

  // Step 2: Undo the offset
  let diff = (mixed - SECRET_OFFSET) % MODULUS;
  if (diff < 0) diff += MODULUS; // handle negative mod

  // Step 3: Multiply by modular inverse of SECRET_PRIME to undo the multiplication
  const inversePrime = modInverse(SECRET_PRIME, MODULUS);
  const userId = (diff * inversePrime) % MODULUS;

  return userId;
}